goog.provide('el8.appshared.newMessage');
goog.provide('el8.appshared.messageReplyForm');

goog.require('el8.appchart.showItemDetail');
goog.require('el8.appservice.notifier');
goog.require('el8.appservice.search');
goog.require('el8.appshared.message');
goog.require('el8.data.practiceUsers');
goog.require('el8.data.staffGroups');
goog.require('el8.ptdata.model.message');
goog.require('el8.service.infoField');
goog.require('el8.service.tz');
goog.require('el8.template.appshared.newMessage');
goog.require('el8.tourguide.InfoBox');
goog.require('el8.uiwidget.acms');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.base');
goog.require('el8.uiwidget.InputFormDialog');
goog.require('el8.uiwidget.NewActionsMenu');
goog.require('el8.util.base');

(function() {

    el8.appshared.newMessage = function() {

        var that = {};
        var container = $('#new-message-ui');

        var currPatient = el8.ptdata.currPatient || null;
        var sender = el8.data.currUser;
        var toDocId = null;
        var sendCallbackFn = null;

        // ------------------------
        // MANAGE & INITIALIZE ALL THE FORM FIELDS
        // ------------------------
        var urgentCheckbox = container.find(':input[name="markUrgent"]');
        var bodyInputField = container.find(':input[name="body"]');
        var bodyField = el8.service.infoField.addInfoField({
            field: bodyInputField,
            infoText: 'write message here...'
        });
        var patientWidget = null;
        var rePtInputField = null;
        if (!currPatient) {
            var $input = container.find("#rePtInput");
            patientWidget = el8.appservice.search.patientField({
                inputField: $input,
                text: 'name of patient concerned...'
            });
            rePtInputField = $input;

        } else {
            var $ptNameDiv = $('<div class="el8StandardFontSize">').text(currPatient.getFullName()); // XSS OK -KF
            container.find('#rePtInput').replaceWith($ptNameDiv);
        }

        var userWidget = new el8.uiwidget.acms( {
            availableItems: getReceiverList(),
            inputContainer: container.find('#toUserInput'),
            selectedContainer: container.find('#toUserSelected'),
            selectedListType: 'unordered',
            listClasses: ['ebs-list-unstyled', 'mb0'],
            removeTriggerText: [' '],
            removeHtmlPlaceAfter: true,
            removeTriggerClasses: [ 'remove' ],
            noneText: [''],
            inputId: 'toUserNewMessage',
            inputClasses: [ 'w100' ],
            selectedClasses: [ 'itemEmphasis' ],
            selectedContainerClasses: [ '' ],
            infoText: 'name(s) of recipients or group of recipients...',
            restrictToAvailable: false,
            selectOnBlur: false,
            autocompleteFormatResult: receiverToStringFn,
            autocompleteFormatSelected: receiverToStringFn,
            hasSelectedFn: checkReqActIfSelfMsg
        });

        var sendDateInputField = container.find(':input[name="sendDate"]');
        var sendDateField = sendDateInputField.el8_datePicker({},
            { infoText: 'date...' }
        );
        var postDateBubble = new el8.tourguide.InfoBox();

        container.on('click', '.remove-referenced-doc-trigger',  function() {
            toDocId = null;
            $('.message-referenced-doc-section', container).hide();
            $('.message-referenced-doc-summary', container).empty();

        }).on('click', '.item-details-trigger',  function() {
            var itemId = $(this).data('id');
            el8.appchart.showItemDetail(itemId);

        }).on('change', ':input[name="sendDate"]',  function() {
            var $this = $(this);
            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('ftue', [el8.data.currUser.getId(),'PostDateLetter']),
                success: function(res) {
                    if (!res.data) { showPostDateLetterFtue($this); }
                }
            });

        });

        function checkReqActIfSelfMsg() {
            if (el8Globals['FEATURES']['KeepReqActOnSelfMsgs']) {
                var senderId = sender.getId();
                var selectedItems = userWidget.getSelectedItemsPureIdArray();
                var recipientIds = selectedItems.map(function(item) {
                    return item.id;
                });


                if (isSelfMessage(senderId, recipientIds)) {
                    container.find(':input[name="leaveReqAct"]').attr( 'checked', true );
                }
            }
        }

        // ---------------------------
        // Send Message functionality
        // ---------------------------
        function sendMessage(spec) {

            var senderId = sender.getId();
            var re = patientWidget ? [ patientWidget.getSelectedId() ] : [ currPatient.getId() ];
            var isUrgent = urgentCheckbox.is(':checked');

            var leaveReqAct = container.find(':input[name="leaveReqAct"]').is(':checked');

            var sendDate = null;
            if (sendDateField.getVal()) {
                sendDate = el8.service.tz.newTzDate(sendDateField.getVal());
            }

            var toUsers = [];
            var toGroups = [];
            var body = '';

            var failRecipient = function(name) {
                // If user can't be found either place, raise an error
                el8.uiwidget.alert('A recipient ("'+name+'") is not valid - please select from autocomplete.');
                return false;
            };

            if (spec) {
                toUsers = spec.toUsers;
                toGroups = spec.toGroups;
                body = spec.body;
                toDocId = spec.toDocId;
                sendCallbackFn = spec.sendCallbackFn;
            } else {
                var selectedItems = userWidget.getSelectedItemsPureIdArray();
                for (var i=0; i < selectedItems.length; i++) {
                    var selectedItem = selectedItems[i];
                    var itemId = parseInt(selectedItem.id, 10);
                    if (!itemId || isNaN(itemId)) {
                        return failRecipient(selectedItem.value);
                    }

                    if (isStaffGroup(itemId)) {
                        toGroups.push(itemId);
                    } else if (el8.data.practiceUsers.getById(itemId)) {
                        toUsers.push(itemId);
                    } else {
                        return failRecipient(selectedItem.value);
                    }
                }
                body = bodyField.getVal();
            }

            // Validate message
            if( toUsers.length === 0 && toGroups.length === 0 ) {
                // Resurrected by Josh, 8/11/10
                el8.uiwidget.alert('At least one recipient must be selected');
                return false;
            }

            if( re.length === 0) {
                el8.uiwidget.alert('A referenced patient is required.');
                return false;
            } else {
                for( var i=0; i<re.length; i++ ) {
                    if( !re[i] ) {
                        el8.uiwidget.alert('A referenced patient is not valid.');
                        return false;
                    }
                }
            }
            if (sendDate && sendDate < el8.service.tz.now() && !el8.util.datecompare.isToday(sendDate)) {
                el8.uiwidget.alert('Post date must be today or later.');
                return false;
            }

            if (body === "") {
                el8.uiwidget.alert("Body cannot be empty");
                return false;
            }

            // Build object to post to server
            var result = {};
            result['isUrgent'] = isUrgent;
            result['senderId'] = senderId;
            result['toUsers'] = toUsers;
            result['toGroups'] = toGroups;
            result['re'] = re;
            result['body'] = body;
            result['attachmentUrl'] = null;
            result['holdId'] = null;
            result['toDocId'] = toDocId;

            result['sendDate'] = !sendDate ? null :
                el8.service.tz.asServerFormatDateTime(sendDate);  // want zeroTime

            /* Add flag to leave in req act if needed */
            result['leave_req_act'] = leaveReqAct;

            var savedCallbackFn = sendCallbackFn; //the dialog-level var will get cleared when the dialog hides
            $.el8_ajax({
                type: 'POST',
                url: '/postThread',
                data: JSON.stringify(result),
                success: function(data) {
                    var threadId = data.id;
                    var thread = el8.ptdata.messageThreads.create(data);
                    el8.appservice.notifier.notify(thread.getNotifyText( 'SAVE_COMPLETE' ));
                    dialog.enableForms();
                    if( savedCallbackFn ) {
                        savedCallbackFn( body, threadId );
                    }
                }
            });

            return true;
        }
        that.sendMessage = sendMessage;


        // ---------------------------
        // Set up the dialog
        // ---------------------------
        var closeFn = function() {
            dialog.disableForms();
            that.hide();
        };
        var cancelFn = function() {
            el8.appservice.notifier.notify('Message discarded');
            if (closeFn) { closeFn(); }
        };
        var sendFn = function() {
            dialog.disableForms();
            var success = sendMessage();
            if( !success ) {
                dialog.enableForms();
            } else {
                closeFn();
            }
        };

        var dialog = el8.uiwidget.InputFormDialog({
            container: container,
            containerId: 'new-message-container',
            dialogWidth: 500,
            dialogHeight: 350,
            position: 'trueCenter',
            title: 'Compose Message',
            makeExpandable: false,
            disableTitlebarClose: true,
            disableTitlebarMinimize: true,
            disableTitlebarExpand: true,
            buttons: {
                'Send' : ['new-message-send-btn', true, sendFn],
                'Discard' : ['new-message-cancel-btn', false, cancelFn]
            },
            // the first field varies, depending on whether this is the chart or practice home
            firstFieldSelector: currPatient ? '#toUserNewMessage' : '#rePtInput'
        });

        that.show = function(spec) {

            // Pre-init all the fields
            dialog.resetForms();
            bodyField.init();
            if (patientWidget) { patientWidget.reset(); }
            userWidget.inputField.init();
            sendDateField.init();

            var toUsers = [];
            var toGroups = [];
            var body = '';
            var rePatientId = null;
            if (spec) {
                toUsers = spec.toUsers;
                toGroups = spec.toGroups;
                body = spec.body;
                toDocId = spec.toDocId;
                sendCallbackFn = spec.sendCallbackFn;
                rePatientId = spec.rePatientId;
            }

            if (body) {
                bodyField.setVal(body);
            }
            // Prepopulate recipients...
            // Expect recipients to be an array of user objects
            if( toUsers && toUsers.length > 0 ) {
                for( var i=0; i<toUsers.length; i++ ) {
                    userWidget.selectItem( toUsers[i].getFullName() );
                }
            }
            if( toGroups && toGroups.length > 0 ) {
                for( var i=0; i<toGroups.length; i++ ) {
                    userWidget.selectItem( toGroups[i].getName() );
                }
            }
            if (rePatientId && patientWidget) {
                var rePatient = el8.ptdata.patients.getById(rePatientId);
                patientWidget.mr.setSelectedItem(null, rePatient.asAutocompleteMap());
            }

            if (toDocId) {
                var doc = el8.ptdata.fetch({
                    fetchId: toDocId,
                    patientId: el8Globals['PATIENT_ID'] || rePatientId
                });
                $('.message-referenced-doc-section', container).show();
                $('.message-referenced-doc-summary', container).html(
                    el8.template.appshared.newMessage.referencedDocSummary({
                        id: doc.getId(),
                        summary: doc.getNoteSummary(),
                        showLink: !!el8Globals['PATIENT_ID']
                    })
                );
            } else {
                $('.message-referenced-doc-section', container).hide();
                $('.message-referenced-doc-summary', container).empty();
            }

            dialog.enableForms();
            dialog.show();

            if (toUsers.length) { bodyField.getInputField().focusFocus(); }
        };

        that.hide = function() {
            dialog.hide();
            userWidget.clearSelectedItems();
            if (patientWidget) { patientWidget.reset(); }
            if (postDateBubble) { postDateBubble.hide(); }
            toDocId = null;
            sendCallbackFn = null;
        };

        function showPostDateLetterFtue($target) {
            postDateBubble.show({
                styleClass: 'el8FTUEBox',
                contentFn: el8.template.appshared.newMessage.postDateFtue,
                height: 110,
                width: 180,
                left: container.offset().left - 187,
                top: $target.offset().top - 30,
                zIndex: $.ui.dialog.maxZ + 1
            });
            postDateBubble.getContainer().on('click', '.learn-more-trigger',  function(e) {
                // URL will be opened in new tab by browser native handling of href
                $.el8_ajax({
                    type: 'POST',
                    url: el8.service.urls.get('ftue', [el8.data.currUser.getId(),'PostDateLetter']),
                });
                postDateBubble.getContainer().off('click', '.learn-more-trigger');
                postDateBubble.hide();
            });
            container.off('change', ':input[name="sendDate"]');
        }

        return that;
    };


    el8.appshared.messageReplyForm = function(spec) {

        var threadId = spec.thread.getId();
        var cardContainer = spec.cardContainer;
        var autoSend = ( spec.autoSend === true );
        var autoSendBody = spec.autoSendBody || '';
        var autoSendAddTo = spec.autoSendAddTo || [];
        var toDocId = spec.toDocId || null;

        var containerClass = 'threadPane_' + threadId;
        var container = cardContainer.hasClass(containerClass) ? cardContainer :
            cardContainer.find('.'+containerClass);
        var replyTrigger = cardContainer.find('#threadReplyTrigger_' + threadId);
        var callbackFn = spec.callbackFn || function(){};
        var closeFn = function() {
            if (spec.closeFn) { spec.closeFn(); }
            actionsMenu.destroy();
        };

        var thread = spec.thread;
        var sender = el8.data.currUser; //thread.getCurrMember().getUser();

        function sendMessage( spec ) {
            var doSignOff = spec ? Boolean(spec.signOff) : false;
            var addTo = [];
            var body = '';
            var isUrgent = false;

            var leaveReqAct = container.find(':input[name="leaveReqAct"]').is(':checked');

            if( spec && !doSignOff ) {
                // Case of auto-reply
                isUrgent = thread.isUrgent();
                body = spec.body;
                addTo = spec.addTo || [];
            } else {
                isUrgent = container.find(':input[name="markUrgent"]').is(':checked');
                // var bodyField = container.find(':input[name="replyBody"]');
                body = bodyField.getVal();
                addTo = userWidget ? userWidget.getSelectedIdsArray() : [];
            }

            if( addTo.length > 0 ) {
                for( var i=0; i<addTo.length; i++ ) {
                    if( !addTo[i] || isNaN(addTo[i]) ) {
                        el8.uiwidget.alert('A recipient is not valid - please select from autocomplete');
                        return false;
                    }
                    if ( doSignOff && isStaffGroup(addTo[i]) ) {
                        el8.uiwidget.alert("If you sign off this message, the staff group(s) " +
                            "that you've added to the thread will not be notified. Please " +
                            "either remove the group or send without signing.");
                        return false;
                    }
                }
            }

            if( body === '' ) {
                el8.uiwidget.alert("Reply cannot be empty");
                return false;
            }

            // Build object to send to server
            var result = {};
            result['id'] = thread.getId();
            result['senderId'] = el8.data.currUser.getId();
            result['body'] = body;
            result['attachmentUrl'] = null;
            result['holdId'] = ( thread.getHold() === null ) ? null : thread.getHold().getId();
            result['isUrgent'] = isUrgent;
            result['addTo'] = addTo;
            result['toDocId'] = toDocId;

            /* Add flag to leave in req act if needed */
            result['leave_req_act'] = leaveReqAct;

            thread.setHold( null );

            $('button', container).prop('disabled', true);

            $.el8_ajax({
                type: 'POST',
                url: "/postThreadReply/" + (doSignOff ? "sign-off/" : ""),
                data: JSON.stringify(result),
                success: function(data) {
                    thread = el8.ptdata.messageThreads.create(data);
                    el8.appservice.notifier.notify(thread.getNotifyText( 'SAVE_COMPLETE' ));
                    callbackFn(thread, data, leaveReqAct);
                },
                error: function(xhr, textStatus, errorThrown) {
                    // Our default error handling ignores status == 0 which we assume are network
                    // issues and lets it be handled by the "no internet" box which should show
                    // eventually. We'll make an exception here since the status message seems
                    // to be currently unrelaible for some users
                    el8.uiwidget.alert('Error sending message. Please check the internet connection and resend.');
                    $('button', container).prop("disabled", false);
                },
                error_msg: function(_status, default_msg) {
                    if (_status === 409) {
                        return "This message was signed off in another window. Please refresh the page to get the updates.";
                    }
                    return default_msg;
                }
            });
            return true;
        }

        function cancelMessage() {
            container.empty();
            container.off('click', '.premadeResponseTrigger');
            userWidget.clearSelectedItems();
            userWidget = null;
            replyTrigger.show();
        }

        function autoReply( body, addTo ) {
            sendMessage({ body: body, addTo: addTo });
        }

        if( autoSend ) {
            autoReply( autoSendBody, autoSendAddTo );

        } else {

            replyTrigger.hide();

            var html = el8.template.appshared.newMessage.messageDialog({
                isUrgent : thread.isUrgent(),
                canSignOff : thread.canUserSign(),
                held : thread.getHold()
            });

            // Append to container
            container.html(html);

            // Create actions menu
            var _actionsContainer = container.closest('ol, ul');
            var actionsMenu = new el8.uiwidget.NewActionsMenu({
                menuId: 'message-reply-form-actions-menu-'+threadId+'-'+el8.util.randomInt(),
                container: _actionsContainer,
                anchorTop: _actionsContainer,
                offsets: {
                    top: 18,
                    left: 3
                },
                width: 200
            });

            // seems like this code is in the habit of leaving bound events behind
            container.off('click', '.premadeResponseTrigger');
            container.on('click', '.premadeResponseTrigger',  function() {
                var addTo = userWidget ? userWidget.getSelectedIdsArray() : [];
                var addToUsers = addTo.map(function(id) {
                    // we only want to include users, not staff groups, here
                    if (el8.data.practiceUsers.getById(id)) { return id; }
                    return null;
                });
                var menu = el8.appshared.message.getPremadeResponseMenu({
                    container: container,
                    item: thread,
                    addTo: addToUsers,
                    callbackFn: callbackFn,
                    closeFn: closeFn
                });
                actionsMenu.display($(this), thread, null, menu);
                return false;
            });

            var existingMemberIds = []; // helper to exclude existing members from to: choices
            var existingMemberGroupIds = [];
            var existingMemberNames = [el8.data.currUser.getFullName()];
            var members = thread.getMembers();
            for( var i=0; i<members.length; i++ ) {
                if (members[i].getUserId()) {
                    existingMemberIds.push(members[i].getUserId());
                } else if (members[i].getGroupId()) {
                    existingMemberGroupIds.push(members[i].getGroupId());
                }
                if( members[i].getGroup() || ( members[i].getUser().getId() !== el8.data.currUser.getId()) ) {
                    existingMemberNames.push(members[i].getMemberName());
                }
            }
            $('#toUsersExisting', container).find('.name-list').text(existingMemberNames.join(', '));

            var bodyField = el8.service.infoField.addInfoField({
                field : container.find(':input[name="replyBody"]'),
                infoText : 'write reply here...'
            });

            // Juse in case el8.data.currUser isn't an existing member
            existingMemberIds.push(sender.getId());

            var userWidget = null;

            var receiverList = getReceiverList();
            if( receiverList.length === 0 ) {
                // TODO man, dangerous; relies on specific DOM structure but this whole file is landmines anyway!
                $('#toUsersExisting', container).next('div.el8TextareaWrap').remove();
            } else {
                userWidget = new el8.uiwidget.acms( {
                    availableItems: receiverList,
                    availableItemsHasId: true,
                    inputContainer: container.find('#toUserReplyInput'),
                    selectedContainer: container.find('#toUserReplySelected'),
                    selectedListType: 'unordered',
                    listClasses: [''],
                    removeTriggerText: ['X'],
                    removeHtmlPlaceAfter: true,
                    removeTriggerClasses: ['remove'],
                    noneText: [''],
                    inputClasses: [ 'w100' ],
                    selectedClasses: [ 'itemEmphasis' ],
                    selectedContainerClasses: [ '' ],
                    infoText: 'type name(s) of recipients to add to thread...',
                    restrictToAvailable: false,
                    selectOnBlur: false,
                    autocompleteFormatResult: receiverToStringFn,
                    autocompleteFormatSelected: receiverToStringFn
                });
            }

            var patients = thread.getPatients();
            for( var i=0; i<patients.length; i++ ) {
                var $elt = $('<span class="elt">').text(patients[i].getPatient().getFullName()); // XSS OK -KF
                container.find('#rePatients').append($elt);
            }

            var hold = thread.getHold();
            if( hold !== null ) {
                container.find(':input[name="replyBody"]').val( hold.getBody() );
                container.find(':input[name="markUrgent"]').attr( 'checked', hold.isUrgent() );
            }

            var $firstField = $(':input[name="replyBody"]', container);
            container.off('focus', '.tabcatcher').on('focus', '.tabcatcher',  function() {
                $firstField.focusSelect();
            });
            $firstField.focusSelect();

            container.find('#reply-send-btn').unbind('click').on('click', function(e) {
                e.preventDefault();
                sendMessage();
                closeFn();
            });

            container.find('#reply-send-signoff-btn').unbind('click').on('click', function(e) {
                e.preventDefault();
                sendMessage({ signOff: true });
                closeFn();
            });

            container.find('#reply-cancel-btn').unbind('click').on('click', function(e) {
                e.preventDefault();
                cancelMessage();
                closeFn();
            });
        }
    };

    function isStaffGroup(id) {
        // Can't rely on just idToModelClass here, because ID might
        // come from a StaffGroup or User. Users are not el8-ids,
        // so sometimes they will appears to be StaffGroups
        // [e.g., el8.model.idToModelClass(13)]
        return (el8.model.idToModelClass(id) === 'StaffGroup' &&
                el8.data.staffGroups.getById(id));
    }

    function isSelfMessage(senderId, recipientIds) {
        // A message is a 'self' message if the sender is in the
        // recipient list, or in a group in the recipient list
        // (recipientIds may be user or group ids, mixed)
        var isSelf = false;

        for (var i = 0; i < recipientIds.length; i++) {
            var recipientId = recipientIds[i];
            var parsedRecipientId = parseInt(recipientId, 10);
            if (parsedRecipientId &&  !isNaN(parsedRecipientId)) {
                if (isStaffGroup(parsedRecipientId)) {
                    var group = el8.data.staffGroups.getById(parsedRecipientId);
                    var groupMembers = group.getUserIds();

                    for (var j = 0; j < groupMembers.length; j++) {
                        if (groupMembers[j] === senderId) {
                            isSelf = true;
                        }
                    }
                } else if (parsedRecipientId === senderId) {
                    isSelf = true;
                }
            }
        }

        return isSelf;
    }

    function receiverToStringFn(item) {
        if (isStaffGroup(item.id)) {
            return item.name + ' (Group)';
        } else {
            return item.fullName;
        }
    }

    function getReceiverList() {
        var receiverList = el8Globals['FEATURES']['MessageGroupsOnly'] ? [] :
            el8.data.practiceUsers.allInWorkspace().map(function(u) {
                var map = u.asSoyMap();
                map.value = map.fullName;
                return map;
            });

        // Now add groups to receiverList as well
        el8.data.staffGroups.allInWorkspace().forEach(function(g) {
            var map = g.asSoyMap();
            map.value = map.name + (' (Group)');
            receiverList.push(map);
        });

        return receiverList;
    }

})();
